<template>
  <div class="mb-5 pb-5">
    <div class="row mt-4">
      <div class="col">
        <Autocomplete
          label="Pipeline"
          name="pipeline"
          v-model="filters.pipeline"
          :items="pipelineList"
          classe="col-13"
          labelIcon="icon asterisk red"
          :multiple="true"
          placeholder="Selecione os pipelines"
        />
      </div>
      <div class="col">
        <Input
          label="Data Inicial"
          v-model="filters.data_ini"
          name="data_ini"
          type="date"
        />
      </div>
      <div class="col">
        <Input
          label="Data Final"
          v-model="filters.data_fim"
          name="data_fim"
          type="date"
        />
      </div>
      <div class="col">
        <Autocomplete
          v-model="filters.atendente"
          name="atendente"
          :items="atendenteList"
          classe="col-13"
          label="Atendente"
          :multiple="true"
          placeholder="Selecione os atendentes"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 filter-buttons">
        <button
          type="button"
          class="btn btn-success btn-sm"
          @click="filtrar"
        >
          <Icon
            type="fas"
            icon="search"
            color="white"
          />
        </button>
        <button
          type="button"
          class="btn btn-cancel btn-sm"
          @click="limpar"
        >
          <Icon
            type="fas"
            icon="times"
            title="Limpar"
          />
        </button>
      </div>
    </div>
    <div class="row mt-4" v-show="filtrou">
      <DataTable
        name="Relatório de Produtividade"
        :headers="headers"
        :data="filteredData"
        :pesquisa="false"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment';
import axios from "axios";

import Icon from '../ui/Icon.vue';
import Select from '../ui/Select.vue';
import Autocomplete from '../ui/Autocomplete.vue';
import Input from '../ui/Input.vue';
import DataTable from '../ui/DataTable.vue';

const defaultFilters = {
  pipeline: [],
  atendente: [],
  data_ini: moment().format('YYYY-MM-01'),
  data_fim: moment().format('YYYY-MM-DD'),
};

export default {
  name: 'RelatorioProdutividade',
  components: {
    Icon,
    Select,
    Autocomplete,
    Input,
    DataTable,
  },
  data() {
    return {
      filtrou: false,
      filters: { ...defaultFilters },
      pipelineList: [],
      atendenteList: [],
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Contatos',
          value: 'contatos',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de clientes atendidos pelo atendente no período'
        },
        {
          text: 'Em Negociação (R$)',
          value: 'em_negociacao',
          align: 'right',
          total: true,
          precision: 2
        },
        {
          text: 'Fechou (R$)',
          value: 'fechou',
          align: 'right',
          total: true,
          precision: 2
        },
        {
          text: 'Perdido (R$)',
          value: 'perdido',
          align: 'right',
          total: true,
          precision: 2
        },
        {
          text: 'Oportunidades Em Aberto',
          value: 'oportunidades_em_aberto',
          align: 'right',
          total: true,
          precision: 0
        },
        {
          text: 'Oportunidades Abertas',
          value: 'oportunidades_abertas',
          align: 'right',
          total: true,
          precision: 0
        },
        {
          text: 'Oportunidades Fechadas',
          value: 'oportunidades_fechadas',
          align: 'right',
          total: true,
          precision: 0,
        },
        {
          text: 'Mensagens',
          value: 'mensagens',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de mensagens enviadas pelo atendente no período'
        },
        {
          text: 'Tarefas Encerradas',
          value: 'tarefas_encerradas',
          align: 'right',
          total: true,
          precision: 0
        },
        {
          text: 'Ligações',
          value: 'ligacoes',
          align: 'right',
          total: true,
          precision: 0
        },
        {
          text: 'Orçamentos em Aberto',
          value: 'orcamentos_em_aberto',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos em aberto no momento'
        },
        {
          text: 'Orçamentos Fechados',
          value: 'orcamentos_fechados',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos fechados no período'
        },
        {
          text: 'Orçamentos Perdidos',
          value: 'orcamentos_perdidos',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos perdidos no período'
        },
        {
          text: 'TMA (min)',
          value: 'tma',
          align: 'right',
          media: true,
          precision: 0,
          info: 'Tempo médio de atendimento das oportunidades atendidas pelo atendente no período (totalizador representa a média do TMA)'
        },
      ],
      data: [],
    };
  },
  computed: {
    filteredData() {
      return this.data.filter(item => {
        // Verifica se todos os campos numéricos são zero ou falsy
        const hasData = 
          (item.contatos && item.contatos > 0) ||
          (item.em_negociacao && item.em_negociacao > 0) ||
          (item.fechou && item.fechou > 0) ||
          (item.perdido && item.perdido > 0) ||
          (item.oportunidades_em_aberto && item.oportunidades_em_aberto > 0) ||
          (item.oportunidades_abertas && item.oportunidades_abertas > 0) ||
          (item.oportunidades_fechadas && item.oportunidades_fechadas > 0) ||
          (item.mensagens && item.mensagens > 0) ||
          (item.tarefas_encerradas && item.tarefas_encerradas > 0) ||
          (item.ligacoes && item.ligacoes > 0) ||
          (item.orcamentos && item.orcamentos > 0) ||
          (item.tma && item.tma > 0);
        
        return hasData;
      });
    }
  },
  mounted() {
    this.getPipelines();
    this.getAtendentes();
  },
  methods: {
    getPipelines() {
      api.get('/painel/oportunidades-pipelines', { params: { data: 1 } })
        .then(response => {
          this.pipelineList = response.data.map(pipeline => ({
            id: pipeline.id,
            value: pipeline.value,
          }));
        })
        .catch(error => {
          console.error('Error fetching pipelines:', error);
        });
    },
    getAtendentes() {
      api.get('/painel/usuarios', { params: { data: 1 } })
        .then(response => {
          this.atendenteList = response.data.map(atendente => ({
            id: atendente.id,
            value: atendente.name,
          }));
        })
        .catch(error => {
          console.error('Error fetching atendentes:', error);
        });
    },
    limpar() {
      this.filters = { ...defaultFilters };
    },
    async filtrar() {
      $("#overlayer-loading").addClass("show-overlayer");
      const params = {
        pipeline: this.filters.pipeline.map(p => p.id),
        atendente: this.filters.atendente.map(a => a.id),
        data_ini: this.filters.data_ini,
        data_fim: this.filters.data_fim,
      };

      await api.get('/painel/fluxo-oportunidades/produtividade/relatorio', { params })
        .then(async response => {
          if (response.data.url) {
            const retorno_url = await axios.get(response.data.url);
            this.data = retorno_url.data;
          } else {
            this.data = response.data.data;
          }
        })
        .catch(error => {
          let errorMessage = 'Erro ao buscar relatório de produtividade';
          if (error.response.data.message) errorMessage = error.response.data.message;
          if (error.response.data.errors) {
            Object.values(error.response.data.errors).forEach(item => {
              errorMessage = errorMessage.concat('</br>', item);
            });
          }
          window.showToastDanger('body', errorMessage);
        })
        .finally(() => {
          this.filtrou = true;
          $("#overlayer-loading").removeClass("show-overlayer");
        });
    },
  },
}
</script>
